import React from "react";
import ComponentHeader from "../../../core/ComponentHeader/ComponentHeader";
import { labels } from "../../../../localization/labels";
import { Form } from "react-bootstrap";
import ReactMarkdown from "react-markdown";

const imageUriTransformer = uri => {
  const publicURL = "public/";
  const baseURL = `${window.location.origin}/`;

  if (uri.startsWith(publicURL)) {
    uri = uri.replace(publicURL, baseURL);
  }
  return uri;
};

const Readme = ({ source }) => {
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <div className="containerShadow">
        <div>
          <ComponentHeader title={labels.information} showBackButton />
        </div>
        <div className="bordered_bottom_rounded">
          <Form className="readmeText">
            <Form.Group>
              <ReactMarkdown
                source={source}
                transformImageUri={imageUriTransformer}
                linkTarget="_blank"
              />
            </Form.Group>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Readme;
